import { render, staticRenderFns } from "./mobilePreview.vue?vue&type=template&id=22fbf300&scoped=true"
import script from "./mobilePreview.vue?vue&type=script&lang=js"
export * from "./mobilePreview.vue?vue&type=script&lang=js"
import style0 from "./mobilePreview.vue?vue&type=style&index=0&id=22fbf300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fbf300",
  null
  
)

export default component.exports